module.exports = __webpack_public_path__ + "static/img/1.e9e72a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/1.png
// module id = UlFd
// module chunks = 2